import { crmConstant } from "services/Crm/constant";
import * as Yup from "yup";


export const ConvertLeadSchema = Yup.object().shape({
    amount: Yup.string()
        .matches(/^\d+$/, crmConstant.amountMustBeNumber)
        .when("showCreateOpportunity", {
            is: true,
            then: (schema) => schema.required(crmConstant.amountRequired),
            otherwise: (schema) => schema.notRequired(),
        }),
    dealName: Yup.string().when("showCreateOpportunity", {
        is: true,
        then: (schema) => schema.required(crmConstant.dealNameRequired),
        otherwise: (schema) => schema.notRequired(),
    }),
    closeDate: Yup.string().when("showCreateOpportunity", {
        is: true,
        then: (schema) => schema.required(crmConstant.closingDateRequired),
        otherwise: (schema) => schema.notRequired(),
    }),
    stage: Yup.string().when("showCreateOpportunity", {
        is: true,
        then: (schema) => schema.required(crmConstant.stageRequired),
        otherwise: (schema) => schema.notRequired(),
    }),
});